export type BillingTabKey = 'reports' | 'plan-details' | 'credits' | 'payment-methods';

export const BILLING_TABS: readonly BillingTabKey[] = [
  'reports',
  'plan-details',
  'credits',
  'payment-methods',
] as const;

export const isRestrictedBillingTab = (tab: BillingTabKey): boolean =>
  tab === 'reports' || tab === 'plan-details' || tab === 'credits';

/** Without BILLING_VIEW, only payment-methods is allowed (#TAG-1807). */
export const parseBillingTab = (
  raw: string | null,
  canViewBilling: boolean,
): BillingTabKey => {
  const tab = (BILLING_TABS as readonly string[]).includes(raw ?? '')
    ? (raw as BillingTabKey)
    : null;
  if (!canViewBilling) return 'payment-methods';
  if (!tab) return 'reports';
  return tab;
};
